import React from 'react'
import Admin from '../../pages-partial/AdminManagement'

const AdminManagement = () => {
  return (
    <div><Admin /></div>
  )
}

export default AdminManagement